import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import Translate from 'translate';

import ChannelCaseService from 'services/ChannelCaseService';
import IncmsService from 'services/IncmsService';
import { toggleLoading } from 'stores/actions/';

class CaseDetailModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {}
    };
  }

  componentWillReceiveProps( nextProps ) {
    if ( !this.props.open && nextProps.open ) {
      this.getData( nextProps.case )
    } else {
      this.setState( { data: {} } )
    }
  }


  getDescriptionType( typeID ){
    const {incmsData} = this.state;

    const typeObject = _.find(incmsData, function(o) { return o.idComplaint === parseInt(typeID); });
    if (typeObject)
      return typeObject.descriptionType
    else
      return typeID 

  }


   getData( data ) {
    this.props.toggleLoading( true );

     ChannelCaseService.getCase( data.id ).then( ( response ) => {
      this.props.toggleLoading( false );

      if ( response.data ) {
        this.setState( { data: response.data } );
      }
    } );

     IncmsService.getRccsData().then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ) { 
        this.setState( { incmsData: response.data.complaintTypeList } )
      }
    } )
  }

  render() {
    const { onClose, open } = this.props;
    const { data } = this.state;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="caseDetail"/></h5>

        {data.typeCase === 'rccs' &&
        <div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate id="reference"/>:</strong> {data.rccsReference}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="complaintSource"/>:</strong> {data.rccsComplaintSource ? data.rccsComplaintSource : '---'}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate id="group"/>:</strong> {data.rccsGroupDescription ? data.rccsGroupDescription : data.rccsGroup}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="type"/>:</strong> {data.rccsTypeDescription ? data.rccsTypeDescription : this.getDescriptionType(data.rccsType)}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate
                id="registeredAt"/>:</strong> {moment( data.registerDate ).format( 'DD/MM/YYYY' )}
              </p>
            </div>
            <div className="col-md-3">
              <strong><Translate id="link"/>:</strong> <i
              className={classNames( 'fa', {
                'fa-check': data.rccsLink,
                'fa-close': !data.rccsLink
              } )}/>
            </div>
            <div className="col-md-3">
              <strong><Translate id="assigned"/>:</strong> <i
              className={classNames( 'fa', {
                'fa-check': data.rccsAssigned,
                'fa-close': !data.rccsAssigned
              } )}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p><strong><Translate
                id="lastChangeOfStatusDate"/>:</strong> {data.lastChangeStatus ? moment( data.lastChangeStatus ).format( 'DD/MM/YYYY' ): '---'}
              </p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="status"/>:</strong> {data.status}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate
                id="agent"/>:</strong> {_.get( data, 'agent.name' )} {_.get( data, 'agent.lastname' )}
              </p>
            </div>
          </div>
          <div><strong><Translate id="comment"/>:</strong> {data.registerComment}</div>
          <br />
          <div><p><strong><Translate id="commentClousure"/>:</strong> {data.commentClousure}</p></div>
        </div>
        }

        {data.typeCase === 'contact' &&
        <div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate id="type"/>:</strong> {data.contactType}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="reason"/>:</strong> {data.contactReason}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate
                id="registeredAt"/>:</strong> {moment( data.registerDate ).format( 'DD/MM/YYYY' )}
              </p>
            </div>
            <div className="col-md-3">
              <strong><Translate id="emergency"/>:</strong> <i
              className={classNames( 'fa', {
                'fa-check': data.contactEmergency,
                'fa-close': !data.contactEmergency
              } )}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate id="status"/>:</strong> {data.status}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate
                id="agent"/>:</strong> {_.get( data, 'agent.name' )} {_.get( data, 'agent.lastname' )}
              </p>
            </div>
          </div>
          <div><strong><Translate id="comment"/>:</strong> {data.registerComment}</div>
        </div>
        }

        {data.typeCase !== 'contact' && data.typeCase !== 'rccs' &&
        <div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate id="complaintNumber"/>:</strong> {data.complaintNumber}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="registeredAt"/>:</strong> {data.creationDate}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate id="status"/>:</strong> {data.status}</p>
            </div>
          </div>
        </div>
        }

      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( CaseDetailModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/CaseDetailModal/index.js